module.exports = __webpack_public_path__ + "img/shanxin.a961e44d.png";